import { z } from "zod";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
/** Inline artifact body metadata for Quality Gate input (Tier 0 Step 2). */
export const ArtifactEntryV1Schema = z
    .object({
    name: z.string().min(1),
    uri: EnreinArtifactUriSchema,
    clientSafe: z.boolean(),
    contentHash: z.string().min(1),
    mimeType: z.string().min(1),
    content: z.string(),
})
    .strict();
//# sourceMappingURL=artifact-entry.js.map